<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { useClass } from "~/composables/local/cn-class"

const props = defineProps<{
	class?: HTMLAttributes["class"]
}>()

const className = useClass(
	"flex items-center justify-center md:h-fit md:w-[460px]",
	() => props.class,
)
</script>

<template>
	<div :class="className">
		<UCard class="size-full flex flex-col items-center justify-center gap-y-4 px-6 py-4 md:py-10">
			<div class="flex items-center justify-center md:hidden">
				<NuxtImg
					src="/website/big-logo.png"
					format="webp"
					fit="inside"
					width="120"
					height="80" />
			</div>

			<slot />

			<div class="flex text-xs text-[#4D4F5C] md:hidden">
				بعد از ثبت نام، می تونی از اشتراک رایگان توکا، استفاده کنی !
			</div>
		</UCard>
	</div>
</template>
